"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.animations = void 0;

/**
 * `regularAnimationTime` time animation.
 */
var regularAnimationTime = 500;
/**
 * `fastAnimationTime` time animation.
 */

var fastAnimationTime = 200;
/**
 * Animation durations.
 */

var duration = {
  fast: "".concat(fastAnimationTime, "ms"),
  regular: "".concat(regularAnimationTime, "ms")
};
/**
 * Bezier.
 */

var bezier = {
  easeInOutQuad: 'cubic-bezier(0.4, 0, 0.2, 1)',
  easeInOutQuart: 'cubic-bezier(0.770, 0, 0.175, 1)'
};
/**
 * Default transition.
 */

var defaultTransition = "".concat(duration.regular, " ease");
/**
 * Fast transition.
 */

var fastTransition = "".concat(duration.fast, " ease");
/**
 * Quart transition.
 */

var quartTransition = "".concat(duration.regular, " ").concat(bezier.easeInOutQuart);
/**
 * Export `animations`.
 */

var animations = {
  bezier: bezier,
  defaultTransition: defaultTransition,
  fastTransition: fastTransition,
  quartTransition: quartTransition
};
exports.animations = animations;